import { render, staticRenderFns } from "./LeaveCodeListAddNew.vue?vue&type=template&id=6fc86471&"
import script from "./LeaveCodeListAddNew.vue?vue&type=script&lang=js&"
export * from "./LeaveCodeListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./LeaveCodeListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports